<template>
  <div>
    <aha-modal
      v-if="!showCreateTeamSuccessModal"
      :title="modalTitle_Createateam"
      @hide="hide()"
    >
      <div class="tab-content pb-4">
        <form @submit.prevent="handleSubmitNewTeam()">
          <aha-input
            type="text"
            v-model="teamName"
            :max-length="100"
            focus
          />
          <p class="text-red-50 mt-2" v-if="textError">
            {{ textError }}
          </p>
        </form>
        <aha-button
          class="float-right mt-5 mb-2"
          :submitting="isCreatingNewTeam"
          @click="handleSubmitNewTeam"
        >
          {{ $i18nPresenter.t("Create") }}
        </aha-button>
      </div>
    </aha-modal>
    <aha-modal
      :title="modalTitle_Yourteamisready"
      @hide="hide()"
      v-if="showCreateTeamSuccessModal"
    >
      <div class="tab-content">
        <img
          class="mb-3 rounded"
          src="@/assets/images/team/create-team-done.gif"
        >
        <p>
          {{ $i18nPresenter.t("Now you can bring your teammates on board to collaborate and achieve great things together!") }}
        </p>
      </div>
      <template #action>
        <aha-button class="float-right mb-2" @click="hideAndRedirect">
          {{ $i18nPresenter.t("Got it!") }}
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import accountApi from '@/api/account'
import Utils from '@/util'
import constant from '@/constant'

export default {
  data() {
    return {
      teamName: '',
      textError: '',
      isCreatingNewTeam: false,
      showCreateTeamSuccessModal: false,
      modalTitle_Createateam: this.$i18nPresenter.t('Create a team'),
    }
  },
  computed: {
    currentUser: (state) => state.currentUser,

    modalTitle_Yourteamisready() {
      return this.$i18nPresenter.t('Your team is ready!')
    },
  },
  mounted() {
    const userFullname = `${this.$store.state.currentUser.firstName} ${this.$store.state.currentUser.lastName}`.replace(/\s+/g, ' ').trim()
    this.teamName = `${userFullname}'s Team`
  },
  methods: {
    ...mapActions([
      'getCurrentUserAction',
      'setCurrentUserAction',
      'setCurrentAccountAction',
      'setErrorOnInternalServerAction',
    ]),
    hide() {
      this.$emit('hide')
    },
    hideAndRedirect() {
      this.$emit('hide')
      this.showCreateTeamSuccessModal = false
      this.$store.state.workingMode = constant.workspace.TEAM
      this.$router.push({ name: 'TeamMember', query: { newTeam: true } })
    },
    async handleSubmitNewTeam() {
      // Tracking 2 times, when click and when created
      if (this.teamName.trim() === '') {
        this.textError = this.$i18nPresenter.t('Please enter a name for team.')
        return
      }
      this.isCreatingNewTeam = true
      Utils.mixpanelTracking('Presenter App', 'SideNav > Create a team > Create', this.teamName.trim(), '', {
        plan: this.$store.state.currentUser.plan,
      })
      try {
        const result = await accountApi.createAccount({ name: this.teamName.trim() })
        const { code, account } = result
        if (code === 'ok') {
          this.showCreateTeamSuccessModal = true
          this.$store.state.currentUser.accountRole = 'owner'
          this.$store.state.currentUser.accountId = account.id
          this.setCurrentAccountAction({
            ...account,
            totalMembers: 1,
          })
          await this.getCurrentUserAction()
          window.localStorage.setItem(`is-already-has-team-${this.$store.state.currentUser.id}`, true)
          Utils.mixpanelTracking('Presenter App', 'SideNav > Create a team > Success', account.name, '', {
            plan: this.$store.state.currentUser.plan,
          })
        } else {
          Utils.showToastError(`${this.$i18nPresenter.t('Team created fail!')}`)
        }
      } catch (error) {
        this.setErrorOnInternalServerAction(`${this.$i18nPresenter.t('Cannot create team:')} ${this.teamName}`)
      }
    },
  },
}
</script>
<style scoped>

</style>
